/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Legacy SNF display names. Use `AdmissionStatusCode`.
 * @export
 */
export const AdmissionStatus = {
    Booked: 'Booked',
    MovedIn: 'Moved-In',
    MovedOut: 'Moved-Out',
    Lost: 'Lost',
    Hospitalized: 'Hospitalized',
    Loa: 'LOA',
    IntakeInProgress: 'Intake in Progress',
    Selected: 'Selected',
    Scheduled: 'Scheduled',
    Admitted: 'Admitted',
    Transferred: 'Transferred',
    Discharged: 'Discharged',
    NoAdmit: 'No Admit',
    ReadyForAdmission: 'Ready for Admission',
    Deceased: 'Deceased',
} as const;
export type AdmissionStatus = typeof AdmissionStatus[keyof typeof AdmissionStatus];


export function instanceOfAdmissionStatus(value: any): boolean {
    for (const key in AdmissionStatus) {
        if (Object.prototype.hasOwnProperty.call(AdmissionStatus, key)) {
            if (AdmissionStatus[key as keyof typeof AdmissionStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AdmissionStatusFromJSON(json: any): AdmissionStatus {
    return AdmissionStatusFromJSONTyped(json, false);
}

export function AdmissionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdmissionStatus {
    return json as AdmissionStatus;
}

export function AdmissionStatusToJSON(value?: AdmissionStatus | null): any {
    return value as any;
}

export function AdmissionStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): AdmissionStatus {
    return value as AdmissionStatus;
}

